import Router from 'vue-routes-generator'
import Main from './main'
import MainStore from '../../core/vue/store/stores'
import MuroStore from './store'
import GestionAlertas from './componentes/alertas/gestion-alertas'

export default {
	install: () => {
		Router.route('/main').child('muro', {
			name: 'Muro',
			component: Main
		})

	    MainStore.registerModule(['muro'], MuroStore)

	    Router.route('/main').child('muro/:id', {
			name: 'Entrada del muro',
			component: Main
	    })

		Router.route('/main').child('gestion-alertas', {
			name: 'Gestión de alertas',
			component: GestionAlertas
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/muro/vue/index.js